import {
	Directive,
	ElementRef,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output
}                             from '@angular/core';
import { IDomTreeChangeData } from '@core/interfaces/common.interfaces';
import { LoggerService }      from '@shared/services/logger.service';

// watches and emits DOM change events
@Directive( {
	selector: '[appDomTreeChanged]'
} )
export class DomTreeChangedDirective implements OnInit, OnDestroy {

	private change$: MutationObserver;

	// MutationObserverInit
	@Input() watchAttributeFilter: string[];
	@Input() watchAttributeOldValue: boolean;
	@Input() watchAttributes = false;
	@Input() watchCharacterData = false;
	@Input() watchCharacterDataOldValue = false;
	@Input() watchChildList = true;
	@Input() watchSubtree = true;
	@Input() watchSpecificChildTimeout = 100;

	// tslint:disable-next-line:no-input-rename
	@Input( 'watchSpecificChildByQuerySelector' ) private _specificChildSelector: string;

	@Output() domChangeEmitter: EventEmitter<IDomTreeChangeData> = new EventEmitter<IDomTreeChangeData>();

	constructor(
		private _elementRef: ElementRef,
		private _logger: LoggerService
	) {}

	private registerDomChangedEventWithSpecificChild(): void {
		let specificChild: HTMLElement;


		this.change$ = new MutationObserver( ( mutationRecordList: MutationRecord[] ) => {
			specificChild = this._elementRef.nativeElement.querySelector( this._specificChildSelector );

			if ( specificChild ) {
				this._elementRef = new ElementRef( specificChild );
				this.change$.disconnect();
				this.registerDomChangedEvent( this._elementRef.nativeElement );
			}
		} );

		this.change$.observe( this._elementRef.nativeElement, { childList: true, subtree: true } );


		const timeout: ReturnType<typeof setTimeout> = setTimeout( () => {
			clearTimeout( timeout );

			if ( !specificChild ) {
				this.change$.disconnect();
				this._logger.debug( 'DomTreeChangedDirective:registerDomChangedEventWithSpecificChild-> specificChild not found, MutationObserver disconnected' );
			}
		}, this.watchSpecificChildTimeout ?? 100 );
	}

	ngOnInit(): void {
		if ( this._specificChildSelector ) {
			this.registerDomChangedEventWithSpecificChild();
		} else {
			this.registerDomChangedEvent( this._elementRef?.nativeElement );
		}

		this.domChangeEmitter.emit( { element: this._elementRef?.nativeElement, mutationRecords: [] } );
	}

	ngOnDestroy(): void {
		this.change$.disconnect();
	}

	registerDomChangedEvent( nativeElement: HTMLElement ): void {
		this.change$ = new MutationObserver( ( mutationRecordList: MutationRecord[] ) => {
			this.domChangeEmitter.emit( { element: nativeElement, mutationRecords: mutationRecordList } );
		} );

		const mutationObserverInit: MutationObserverInit = {
			attributeFilter: this.watchAttributeFilter,
			attributeOldValue: this.watchAttributeOldValue,
			attributes: this.watchAttributes,
			characterData: this.watchCharacterData,
			characterDataOldValue: this.watchCharacterDataOldValue,
			childList: this.watchChildList,
			subtree: this.watchSubtree
		};

		this.change$.observe( nativeElement, mutationObserverInit );
	}
}


